import React from "react";

const ShareIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="64" height="64">
    <g fill="none" fill-rule="evenodd">
      <g transform="translate(17 11)">
        <use xlinkHref="#b" fill="#000" filter="url(#a)" />
        <rect width="39" height="39" x=".5" y=".5" fill="#FFF" stroke="#FFF" stroke-linejoin="square" rx="19.5" />
      </g>
      <path d="M26 21h20v20H26z" />
      <path
        fill="#000"
        fill-rule="nonzero"
        d="M41 34.4c-.633 0-1.2.25-1.633.642l-5.942-3.459c.042-.191.075-.383.075-.583 0-.2-.033-.392-.075-.583l5.875-3.425a2.49 2.49 0 0 0 1.7.675c1.383 0 2.5-1.117 2.5-2.5 0-1.384-1.117-2.5-2.5-2.5a2.497 2.497 0 0 0-2.5 2.5c0 .2.033.391.075.583L32.7 29.175A2.49 2.49 0 0 0 31 28.5a2.497 2.497 0 0 0-2.5 2.5c0 1.383 1.117 2.5 2.5 2.5a2.49 2.49 0 0 0 1.7-.675l5.933 3.467a2.351 2.351 0 0 0-.066.541A2.436 2.436 0 0 0 41 39.267a2.436 2.436 0 0 0 2.433-2.434A2.436 2.436 0 0 0 41 34.4zm0-10.067c.458 0 .833.375.833.834A.836.836 0 0 1 41 26a.836.836 0 0 1-.833-.833c0-.459.375-.834.833-.834zm-10 7.5a.836.836 0 0 1-.833-.833c0-.458.375-.833.833-.833.458 0 .833.375.833.833a.836.836 0 0 1-.833.833zm10 5.85a.836.836 0 0 1-.833-.833c0-.458.375-.833.833-.833.458 0 .833.375.833.833a.836.836 0 0 1-.833.833z"
      />
    </g>
  </svg>
);

export default ShareIcon;
